// vendor
// -------------------------------------------------------------------------
import $ from "jquery";
import "./vendor/slick.js";
import "./vendor/youtube.js";

// animation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export { gsap, ScrollTrigger };
gsap.registerPlugin(ScrollTrigger);

import "./vendor/animation.js";
import "./vendor/scroll.js";
import { startAnimation } from './vendor/animation';

window.addEventListener("resize", () => {
    ScrollTrigger.refresh();
});

// window.addEventListener("load", function() {
//     startAnimation();
// });


import "./vendor/lottie.js";

// component
// -------------------------------------------------------------------------
import "./component/hamburger.js";
import "./component/navigation.js";
import "./component/splash.js";
import "./component/deco-flare.js";


// Instagram
// -------------------------------------------------------------------------
function fetchInstagramData() {
    var tokens = {
        "17841430330997111": "EAAbfUp2F1g0BAGSZCunj4t3AAqzUcF6Oo1LckYUbXIzYQRZAtIgZCdysUugCJYN608DsbcaNAvGqG5iFQSRy9zwZCqHKL1wabZCZAvZAYLhnUS0aRmQMYRJ1yR8N4gXUHWOZB8XwQWzkbn6Oe0DzihwvZBJ9ZA8iuZBJJ8xwgHbUrSfeYvhLOTSLcJKY8O5gZCkLJW0ZD"
    };

    $(".js-insta-graph-api").each(function() {
        var $element = $(this),
            id = $element.data("id"),
            limit = $element.data("limit"),
            apiUrl = "https://graph.facebook.com/v3.0/" + id + "?fields=name%2Cmedia.limit(" + limit + ")%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cusername%7D&access_token=" + tokens[id];

        $.ajax({
            type: "GET",
            url: apiUrl,
            dataType: "json",
            success: function(response) {
                var mediaData = response.media.data,
                    htmlContent = '<ul class="illumi-instagram__items">';

                for (var i = 0; i < mediaData.length; i++) {
                    var mediaUrl = mediaData[i].media_url;
                    var mediaContent;

                    if (mediaUrl.match(/\.mp4/)) {
                        // 動画の場合
                        mediaContent = '<video controls loading="lazy"><source src="' + mediaUrl + '" type="video/mp4"></video>';
                    } else {
                        // 画像の場合
                        mediaContent = '<img src="' + mediaUrl + '" alt="" loading="lazy">';
                    }

                    htmlContent += '<li class="illumi-instagram__item"><a href="' + mediaData[i].permalink + '" target="_blank"><div class="js-trim-img__target">' + mediaContent + '</div></a></li>';
                }

                htmlContent += "</ul>";
                $element.find(".js-insta-graph-api__target").append(htmlContent);
                ScrollTrigger.refresh();
            },
            error: function(err) {
                console.error("Instagram API error:", err);
            }
        });
    });
}

fetchInstagramData();
